import Header from "../components/dashboard/common/header";
import Sidebar from "../components/dashboard/common/sidebar";
import {Box, createTheme, CssBaseline, GlobalStyles, ThemeProvider} from "@mui/material";
import useThemeStore from "../store/theme";
import {useEffect, useMemo, useState} from "react";
import {prefixer} from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import {CacheProvider} from "@emotion/react";
import {ToastyContainer} from "../theme/components/ToastyContainer";
import createCache from "@emotion/cache";
import dashboardTheme from "../theme/dashboardTheme";
import {useUser} from "../lib/hooks";
import Loading from "../components/dashboard/common/loading";
import {getAppVersion} from "../lib/services/drive";
import UpdateAppModal from "../components/dashboard/common/updateAppModal";
import CompleteInfoModal from "../components/dashboard/common/completeInfoModal";
import DownloadPopup from "../components/common/downloadPopup";

const DashboardLayout = ({children}) => {

    const user = useUser({redirectTo: "/drive/login"});
    const mode = useThemeStore((state) => state.mode);
    // Update the theme only if the mode changes
    const theTheme = useMemo(() => createTheme(dashboardTheme(mode)), [mode]);

    // Create rtl cache
    const cacheRtl = createCache({
        key: 'muirtl',
        stylisPlugins: [prefixer, rtlPlugin],
    });

    const [completeInfoModal, setCompleteInfoModal] = useState(false);
    const [showedModal, setShowedModal] = useState(false);
    // Check for Update
    const [haveUpdate, setHaveUpdate] = useState(false);
    const [showedDialog, setShowedDialog] = useState(false);
    const [newVersion, setNewVersion] = useState('');
    const handleUpdateApp = () => {
        localStorage.setItem('appVersion', newVersion);
        window.location.reload(true); // hard refresh
    }
    useEffect(() => {
        if (user && !user.firstName && !showedModal) {
            setCompleteInfoModal(true);
        }
        if (user && !showedDialog) {
            getAppVersion()
                .then(res => {
                    const {data} = res;
                    if (data.isSuccess) {
                        const prevAppVersion = localStorage.getItem('appVersion');
                        if (prevAppVersion && prevAppVersion !== data.value) {
                            setShowedDialog(true);
                            setNewVersion(data.value);
                            setHaveUpdate(true);
                        } else {
                            localStorage.setItem('appVersion', data.value);
                        }
                    }
                })
                .catch(err => console.log(err));
        }
    }, [user]);

    return (
        <CacheProvider value={cacheRtl}>
            <ThemeProvider theme={theTheme}>
                <CssBaseline/>
                <GlobalStyles styles={`@import url("/assets/css/dashboard.css");`}/>
                {user
                    ?
                    <>
                        <Header/>
                        <Sidebar/>
                        <Box component="main" sx={{ pt: {xs: '5rem', lg: '6rem'}, ml: {lg: '20vw', xl: "18vw"} }}>
                            {children}
                        </Box>
                    </>
                    :
                    <Loading/>
                }
                {haveUpdate && (
                    <UpdateAppModal
                        open={haveUpdate}
                        onClose={() => setHaveUpdate(false)}
                        onConfirm={handleUpdateApp}/>
                )}
                {completeInfoModal && (
                    <CompleteInfoModal
                        open={true}
                        onClose={() => {setCompleteInfoModal(false); setShowedModal(true)}}/>
                )}
                <DownloadPopup/>
                <ToastyContainer/>
            </ThemeProvider>
        </CacheProvider>
    );
}
export default DashboardLayout;